var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVuesaxOutlineHappyemoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_happyemoji",
    "data-name": "vuesax/outline/happyemoji",
    transform: "translate(-493 -445.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "happyemoji"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.75,21.5A10.75,10.75,0,1,1,21.5,10.75,10.765,10.765,0,0,1,10.75,21.5Zm0-20A9.25,9.25,0,1,0,20,10.75,9.261,9.261,0,0,0,10.75,1.5Z",
    transform: "translate(493 445.25)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M5.535,4a6.576,6.576,0,0,1-5.4-2.82A.742.742,0,0,1,.325.135a.742.742,0,0,1,1.04.19,5.1,5.1,0,0,0,4.17,2.18A5.072,5.072,0,0,0,9.705.325a.748.748,0,0,1,1.23.85A6.576,6.576,0,0,1,5.535,4Z",
    transform: "translate(498 458.255)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(507 452)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(500 452)",
    fill: "#061133"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineHappyemoji);
export default __webpack_public_path__ + "static/media/vuesax-outline-happyemoji.255ae5f76d09ec716927d1f00cb470af.svg";
export { ForwardRef as ReactComponent };